import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";
import { CvpEmailPhoneStatus } from "./checkEmailVerificationForCandidate";

export interface PhoneVerificationForCandidateResponse extends BackendResponse {
  item: CvpEmailPhoneStatus;
  candidateCurrentPhone: string;
  candidatePendingPhone: string;
  skippedCrossConcernCheckInDevmode: boolean;
}

export const checkPhoneVerification =
  withNextApi<PhoneVerificationForCandidateResponse>(
    "/cvp/CvpCheckPhoneVerification"
  );
